import React from 'react';
import './Don_t_miss.css';
// Dernek logosu: logo-iskocya.png'nin kırpılmış/küçültülmüş web kopyası.
// Ham dosya 2295x3060 ve tuvalinin %32'si boş; 105px'lik kutuya konunca hem
// 0.6MB indiriliyor hem de logo belirgin küçük duruyor.
import fenerbahceLogo from '../assets/logo-iskocya-web.png';

const DontMissBar = () => {
  return (
    <div className="dont-miss-bar">
      <div className="dont-miss-background">
        <div className="background-navy"></div>
        <div className="background-yellow"></div>
      </div>
      <div className="dont-miss-content">
        <div className="dont-miss-logo-container">
          <img src={fenerbahceLogo} alt="İskoçya Fenerbahçeliler Derneği Logosu" className="dont-miss-logo" />
        </div>
      </div>
    </div>
  );
};

export default DontMissBar; 